import styled from 'styled-components';

export const Label = styled.label`
  display: block;
  font-size: ${({ $labelSize, theme }) =>
    $labelSize === 'heading' ? theme.fontsize.h3 : theme.fontsize.base};
`;
